// 챗봇 운영 설정(계약 §12, 대표). 설정 행이 없으면 GET 이 404 — 그때는 null, 저장은 POST 로 만든다.
import { http, data } from "../../inquiry/v6Api";

export async function getSetting() {
    try { return await data(http.get("/system/setting")); }
    catch (e) { if (e?.response?.status === 404) return null; throw e; }
}
// exists=false 면 PATCH 가 404 이므로 POST(필수: 환영 제목·내용, 전화, 이메일)
export const saveSetting = (body, exists) =>
    data(exists ? http.patch("/system/setting", body) : http.post("/system/setting", body));

export const getQuickCategories = () => data(http.get("/system/quick-categories"));
// 목록 전체 교체 — 빠진 id 는 지워지고 순서는 배열 순서
export const putQuickCategories = (rows) => data(http.put("/system/quick-categories", rows));
export const getMeta = () => data(http.get("/inquiries/meta"));
